import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { BackendListModel } from "../../../models/common/list.model";

@Injectable({
  providedIn: 'root'
})
export class AutoSearchService {

  constructor(private http: HttpClient) { }

  retrieveObject(url) {
    return this.http.get(url)
  }

  listObjects(url) {
    return this.http.get<BackendListModel<any>>(url);
  }
}
